module.exports = __webpack_public_path__ + "img/defensoria-logo-nuevo-h.d8a0706f.png";